<div [formGroup]="form">
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">{{state.Title}}</h4>
  </div>

  <div class="modal-body">
    @if (state.SubTitle) {
      <p>{{state.SubTitle}}</p>
      <br />
    }

    @if (state.ShowInputFields && trackingUiActionRunTimeDisplayGroups.length > 0) {
      <ep-datafield-group-container [formValidationGroup]="form" [showError]="true" [datafieldGroups]="trackingUiActionRunTimeDisplayGroups"
        [isAlwaysEditable]="true" [numberOfColumns]="1">
      </ep-datafield-group-container>
      <br />
    }

    @if (!state.ShowRejected && !state.ShowInputFields && validationResult?.Accepted?.length) {
      <p>✔️ {{ validationResult?.Accepted?.length ?? 0 }} document{{ validationResult?.Accepted?.length === 1 ? '' : 's' }} accepted for {{state.Title}}</p>
    }

    @if (state.ShowRejected) {
      <p>✔️ {{ validationResult.Accepted?.length }} document{{ validationResult.Accepted?.length === 1 ? '' : 's' }} accepted</p>
      <br />
      <p>❌ {{ validationResult.Rejected?.length }} document{{ validationResult.Rejected?.length === 1 ? '' : 's' }} rejected</p>
      <dx-data-grid biz-grid [dataSource]='validationResult.Rejected' [showBorders]="true" [bizSetColumnChooser]="false" [bizSetAllowColumnReordering]="false"
        [bizSetSearchPanel]="false" [bizHideSelectedRowsComponent]="true" [showResetButton]="false" [bizSetGroupPanel]="false" [bizSetPager]="false"
        [bizSetPaging]="false">
        <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
        <dxi-column dataField="Document.InterchangeInId" caption="Interchange In Id" dataType="string" [allowSorting]="false"
        [allowFiltering]="false"></dxi-column>
        <dxi-column dataField="Document.DocumentId" caption="Document Id" dataType="string" [allowSorting]="false" [allowFiltering]="false"></dxi-column>
        <dxi-column dataField="Reason" dataType="string" [allowSorting]="false" [allowFiltering]="false"></dxi-column>
      </dx-data-grid>
    }

  </div>
  <div class="modal-footer">
    @if (validationResult?.Accepted?.length) {
      <button type="button" class="btn btn-primary" [disabled]="(state.ReadyForAction && form.invalid) || !state.OkEnabled"
      (click)="ok()">{{state.OkLabel}}</button>
      <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
    }
    @if (!validationResult?.Accepted?.length) {
      <button type="button" class="btn btn-secondary" (click)="cancel()">Close</button>
    }
  </div>
</div>
